import { Component, OnInit, ElementRef, NgZone } from '@angular/core';

@Component({
  selector: 'app-theme-builder',
  templateUrl: './theme-builder.component.html',
  styleUrls: ['./theme-builder.component.scss']
})
export class ThemeBuilderComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}
